import * as React from 'react'
import { Button, Icon } from '@alifd/next';
import { useAppSelector } from '../../redux/hooks';
import OrderExpress from '../../components/actions/logistics-action/order-express'
import openXman from '../../common/xman';
import doLog from '../../common/log';
import AddCart from './add-cart';
import OrderBtn from './order-btn';
import CallUsBtn from './call-us';
import ContactSupplier from './contact-supplier';

const {useState} = React;

export default function goods(props: any) {
  const {type, moq, hasVideoChat, i18n} = props;

  const [btnLoading, setBtnLoading] = useState(false);
  const [tipShow, setTipShow] = useState(false);
  
  // 获取sku信息
  const skuInfo = useAppSelector( state =>  state.sku[type]);
  const selectSkuInfo = Object.values(skuInfo.map).filter((i:any) => i.number > 0);
  
  const quantity = selectSkuInfo.reduce((a: any, {number = 0}: any) => a + number, 0);


  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if ( quantity < moq ) {
      doLog(
        '/sc.details.soBtn',
        'position=top',
        );
        setTipShow( true );
        return;
      }
      setBtnLoading(true);
      const formDom = e.target;
      openXman(() => {
        doLog(
          '/sc.details.soBtn',
          'position=top',
        );
        formDom.submit();
      }, 
      () => setBtnLoading(false))
  }
  
  return (
    <div className="main-actions goods">
      <form
        onSubmit={handleSubmit}
        action={`//biz.alibaba.com/contract/nowBuy.htm?pageId=${window.dmtrack_pageid}`}
        method="post"
      >
        <OrderExpress {...props}
          quantity={quantity}>
          <OrderBtn {...props} setTipShow={setTipShow} tipShow={tipShow} btnLoading={btnLoading}/>
        </OrderExpress>
        <div className="action-item">
          <ContactSupplier {...props}>
              <Button type="secondary">
                <Icon type="email" />{i18n['mainAction_operate_contact']}
            </Button>
          </ContactSupplier> 
        </div>
        {hasVideoChat && <div className="action-item">
          <CallUsBtn {...props}/>
        </div>}
        {!skuInfo.isSoldOut && <AddCart {...props} selectSkuInfo={selectSkuInfo} isSoldOut={skuInfo.isSoldOut}/>}
      </form>
    </div>
  )
}
